import i18n from '@i18next/i18n';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import { IHSL } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { IThemeSelectItem } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';

export const CLASSIC_KEY = 'classic';
export const CUSTOM_KEY = 'custom';
export const BUSINESS_KEY = 'business';
export const FRESH_KEY = 'fresh';
export const SCIENCE_KEY = 'science';

export const TAB_BUTTON_LIST = [
    {
        title: i18n.t('经典'),
        key: CLASSIC_KEY,
    },
    // 三期自定义
    {
        title: i18n.t('自定义'),
        key: CUSTOM_KEY,
    },
];

const list = [
    {
        hsl: {
            H: 0,
            S: 0,
            L: 255,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 242,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 216,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 191,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 165,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 147,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 0,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 127,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 89,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 63,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 38,
        },
    },
    {
        hsl: {
            H: 0,
            S: 0,
            L: 13,
        },
    },
    {
        hsl: {
            H: 219.37499999999997,
            S: 46.36363636363637,
            L: 88,
        },
    },
    {
        hsl: {
            H: 209.99999999999974,
            S: 51.00000000000021,
            L: 244.99999999999997,
        },
    },
    {
        hsl: {
            H: 218.57142857142858,
            S: 34.99999999999994,
            L: 204,
        },
    },
    {
        hsl: {
            H: 217.99999999999997,
            S: 34.15178571428572,
            L: 143,
        },
    },
    {
        hsl: {
            H: 217.49999999999994,
            S: 33.44262295081966,
            L: 60.99999999999999,
        },
    },
    {
        hsl: {
            H: 221.99999999999994,
            S: 31.09756097560976,
            L: 40.99999999999999,
        },
    },
    {
        hsl: {
            H: 218.42364532019707,
            S: 230.06666666666672,
            L: 142.5,
        },
    },
    {
        hsl: {
            H: 216.9230769230769,
            S: 255,
            L: 242,
        },
    },
    {
        hsl: {
            H: 217.49999999999994,
            S: 255,
            L: 227,
        },
    },
    {
        hsl: {
            H: 218.23529411764704,
            S: 255,
            L: 204,
        },
    },
    {
        hsl: {
            H: 218.0487804878049,
            S: 204.99999999999997,
            L: 102,
        },
    },
    {
        hsl: {
            H: 217.9591836734693,
            S: 204.8360655737705,
            L: 61,
        },
    },
    {
        hsl: {
            H: 200.08163265306112,
            S: 255,
            L: 122.5,
        },
    },
    {
        hsl: {
            H: 200.7692307692308,
            S: 255,
            L: 242,
        },
    },
    {
        hsl: {
            H: 200.35714285714278,
            S: 255,
            L: 227,
        },
    },
    {
        hsl: {
            H: 200.00000000000006,
            S: 255,
            L: 204,
        },
    },
    {
        hsl: {
            H: 200.00000000000006,
            S: 204.83606557377053,
            L: 91.5,
        },
    },
    {
        hsl: {
            H: 199.75609756097555,
            S: 204.99999999999997,
            L: 51,
        },
    },
    {
        hsl: {
            H: 147.7358490566038,
            S: 132.5,
            L: 101.99999999999999,
        },
    },
    {
        hsl: {
            H: 146.25,
            S: 156.92307692307696,
            L: 242,
        },
    },
    {
        hsl: {
            H: 147.69230769230774,
            S: 122.77777777777771,
            L: 214.49999999999997,
        },
    },
    {
        hsl: {
            H: 148.57142857142856,
            S: 112.34265734265738,
            L: 183.5,
        },
    },
    {
        hsl: {
            H: 148.23529411764704,
            S: 132.9754601226994,
            L: 81.5,
        },
    },
    {
        hsl: {
            H: 148.88888888888886,
            S: 135,
            L: 51,
        },
    },
    {
        hsl: {
            H: 2.1428571428571352,
            S: 183.07692307692307,
            L: 138,
        },
    },
    {
        hsl: {
            H: 2.6086956521738847,
            S: 255,
            L: 243.49999999999997,
        },
    },
    {
        hsl: {
            H: 2.1428571428571352,
            S: 255,
            L: 227,
        },
    },
    {
        hsl: {
            H: 1.764705882352935,
            S: 255,
            L: 204,
        },
    },
    {
        hsl: {
            H: 1.8181818181818699,
            S: 182.93478260869568,
            L: 92,
        },
    },
    {
        hsl: {
            H: 2.4324324324324076,
            S: 184.99999999999997,
            L: 51,
        },
    },
    {
        hsl: {
            H: 28.151658767772503,
            S: 239.13333333333335,
            L: 142.5,
        },
    },
    {
        hsl: {
            H: 23.999999999999993,
            S: 255,
            L: 244.99999999999997,
        },
    },
    {
        hsl: {
            H: 24.406779661016962,
            S: 255,
            L: 225.5,
        },
    },
    {
        hsl: {
            H: 26.34146341463413,
            S: 255,
            L: 193.5,
        },
    },
    {
        hsl: {
            H: 27.8048780487805,
            S: 204.99999999999997,
            L: 102,
        },
    },
    {
        hsl: {
            H: 27.8048780487805,
            S: 204.99999999999997,
            L: 51,
        },
    },
    {
        hsl: {
            H: 48.00000000000003,
            S: 255,
            L: 122.5,
        },
    },
    {
        hsl: {
            H: 47.142857142857096,
            S: 255,
            L: 241,
        },
    },
    {
        hsl: {
            H: 47.56097560975613,
            S: 255,
            L: 214,
        },
    },
    {
        hsl: {
            H: 47.83216783216781,
            S: 255,
            L: 183.5,
        },
    },
    {
        hsl: {
            H: 47.85276073619637,
            S: 255,
            L: 81.5,
        },
    },
    {
        hsl: {
            H: 48.235294117647044,
            S: 255,
            L: 51,
        },
    },
    {
        hsl: {
            H: 276.98113207547175,
            S: 169.64435146443518,
            L: 135.5,
        },
    },
    {
        hsl: {
            H: 294,
            S: 255,
            L: 244.99999999999997,
        },
    },
    {
        hsl: {
            H: 286.0714285714286,
            S: 255,
            L: 227,
        },
    },
    {
        hsl: {
            H: 277.69911504424783,
            S: 255,
            L: 198.5,
        },
    },
    {
        hsl: {
            H: 277.89473684210526,
            S: 148.6196319018405,
            L: 81.5,
        },
    },
    {
        hsl: {
            H: 278,
            S: 150,
            L: 50.99999999999999,
        },
    },
];

// 老色盘映射
export const EditPaletteThemeColor = [
    {
        color: '#FFFFFF',
        tip: i18n.t('白'),
    },
    {
        color: '#F2F2F2',
        tip: i18n.t('浅灰1'),
    },
    {
        color: '#D8D8D8',
        tip: i18n.t('浅灰2'),
    },
    {
        color: '#BFBFBF',
        tip: i18n.t('浅灰3'),
    },
    {
        color: '#A5A5A5',
        tip: i18n.t('浅灰4'),
    },
    {
        color: '#939393',
        tip: i18n.t('浅灰5'),
    },
    {
        color: '#000000',
        tip: i18n.t('黑'),
    },
    {
        color: '#7F7F7F',
        tip: i18n.t('深灰1'),
    },
    {
        color: '#595959',
        tip: i18n.t('深灰2'),
    },
    {
        color: '#3F3F3F',
        tip: i18n.t('深灰3'),
    },
    {
        color: '#262626',
        tip: i18n.t('深灰4'),
    },
    {
        color: '#0D0D0D',
        tip: i18n.t('深灰5'),
    },

    {
        color: '#485368',
        tip: i18n.t('蓝灰'),
    },
    {
        color: '#F3F5F7',
        tip: i18n.t('浅蓝灰1'),
    },
    {
        color: '#C5CAD3',
        tip: i18n.t('浅蓝灰2'),
    },
    {
        color: '#808B9E',
        tip: i18n.t('浅蓝灰3'),
    },
    {
        color: '#353B45',
        tip: i18n.t('深蓝灰1'),
    },
    {
        color: '#24272E',
        tip: i18n.t('深蓝灰2'),
    },
    {
        color: '#2972F4',
        tip: i18n.t('蓝'),
    },
    {
        color: '#E5EFFF',
        tip: i18n.t('浅蓝1'),
    },
    {
        color: '#C7DCFF',
        tip: i18n.t('浅蓝2'),
    },
    {
        color: '#99BEFF',
        tip: i18n.t('浅蓝3'),
    },
    {
        color: '#1450B8',
        tip: i18n.t('深蓝1'),
    },
    {
        color: '#0C306E',
        tip: i18n.t('深蓝2'),
    },
    {
        color: '#00A3F5',
        tip: i18n.t('天蓝'),
    },
    {
        color: '#E5F6FF',
        tip: i18n.t('浅天蓝1'),
    },
    {
        color: '#C7ECFF',
        tip: i18n.t('浅天蓝2'),
    },
    {
        color: '#99DDFF',
        tip: i18n.t('浅天蓝3'),
    },
    {
        color: '#1274A5',
        tip: i18n.t('深天蓝1'),
    },
    {
        color: '#0A415C',
        tip: i18n.t('深天蓝2'),
    },
    {
        color: '#319B62',
        tip: i18n.t('绿'),
    },
    {
        color: '#EAFAF1',
        tip: i18n.t('浅绿1'),
    },
    {
        color: '#C3EAD5',
        tip: i18n.t('浅绿2'),
    },
    {
        color: '#98D7B6',
        tip: i18n.t('浅绿3'),
    },
    {
        color: '#277C4F',
        tip: i18n.t('深绿1'),
    },
    {
        color: '#184E32',
        tip: i18n.t('深绿2'),
    },
    {
        color: '#DE3C36',
        tip: i18n.t('红'),
    },
    {
        color: '#FFE9E8',
        tip: i18n.t('浅红1'),
    },
    {
        color: '#FFC9C7',
        tip: i18n.t('浅红2'),
    },
    {
        color: '#FF9C99',
        tip: i18n.t('浅红3'),
    },
    {
        color: '#9E1E1A',
        tip: i18n.t('深红1'),
    },
    {
        color: '#58110E',
        tip: i18n.t('深红2'),
    },
    {
        color: '#F88825',
        tip: i18n.t('橙'),
    },
    {
        color: '#FFF3EB',
        tip: i18n.t('浅橙1'),
    },
    {
        color: '#FFDCC4',
        tip: i18n.t('浅橙2'),
    },
    {
        color: '#FFBA84',
        tip: i18n.t('浅橙3'),
    },
    {
        color: '#B86014',
        tip: i18n.t('深橙1'),
    },
    {
        color: '#5C300A',
        tip: i18n.t('深橙2'),
    },
    {
        color: '#F5C400',
        tip: i18n.t('黄'),
    },
    {
        color: '#FFF9E3',
        tip: i18n.t('浅黄1'),
    },
    {
        color: '#FFEEAD',
        tip: i18n.t('浅黄2'),
    },
    {
        color: '#FFE270',
        tip: i18n.t('浅黄3'),
    },
    {
        color: '#A38200',
        tip: i18n.t('深黄1'),
    },
    {
        color: '#665200',
        tip: i18n.t('深黄2'),
    },
    {
        color: '#9A38D7',
        tip: i18n.t('紫'),
    },
    {
        color: '#FDEBFF',
        tip: i18n.t('浅紫1'),
    },
    {
        color: '#F2C7FF',
        tip: i18n.t('浅紫2'),
    },
    {
        color: '#D58EFF',
        tip: i18n.t('浅紫3'),
    },
    {
        color: '#5E2281',
        tip: i18n.t('深紫1'),
    },
    {
        color: '#3B1551',
        tip: i18n.t('深紫2'),
    },
];

const DEFAULT_DK_1 = {
    val: STSchemeColorVal.dk1,
    color: '000000',
};

const DEFAULT_LT_1 = {
    val: STSchemeColorVal.lt1,
    color: 'ffffff',
};

const DEFAULT_HLINK = {
    val: STSchemeColorVal.hlink,
    color: '175CEB',
};

const DEFAULT_FOLHLINK = {
    val: STSchemeColorVal.folHlink,
    color: '81868F',
};

export const DEFAULT_CONFIG: IThemeSelectItem = {
    id: 'Office',
    title: 'Office',
    isVip: false,
    colorSchema: {
        dk1: DEFAULT_DK_1,
        lt1: DEFAULT_LT_1,
        dk2: {
            val: STSchemeColorVal.dk2,
            color: '44546A',
        },
        lt2: {
            val: STSchemeColorVal.lt2,
            color: 'E7E6E6',
        },
        accent1: {
            val: STSchemeColorVal.accent1,
            color: '4472C4',
        },
        accent2: {
            val: STSchemeColorVal.accent2,
            color: 'ED7D31',
        },
        accent3: {
            val: STSchemeColorVal.accent3,
            color: 'A5A5A5',
        },
        accent4: {
            val: STSchemeColorVal.accent4,
            color: 'FFC000',
        },
        accent5: {
            val: STSchemeColorVal.accent5,
            color: '5B9BD5',
        },
        accent6: {
            val: STSchemeColorVal.accent6,
            color: '70AD47',
        },
        hlink: {
            val: STSchemeColorVal.hlink,
            color: '0563C1',
        },
        folHlink: {
            val: STSchemeColorVal.folHlink,
            color: '954F72',
        },
    },
};

export const CLASSIC_THEME: Array<IThemeSelectItem> = [
    {
        id: 'Tencent',
        title: i18n.t('腾讯文档'),
        isVip: false,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '485368',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: '2972F4',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '00A3F5',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: '319B62',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: 'DE3C36',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: 'F88825',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: 'F5C400',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '9A38D7',
            },
        },
    },
    DEFAULT_CONFIG,
    {
        id: 'theme_vip_1',
        title: i18n.t('空境蓝调'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '1C2645',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'D5E3EC',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '246CB8',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'BFE5FA',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: '8CBADE',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '4D749F',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '6C97DF',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '0847B1',
            },
        },
    },
    {
        id: 'theme_vip_2',
        title: i18n.t('向阳橘黄'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '503719',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'F5F3E9',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: 'E4943D',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'F8D7A3',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: 'E3B566',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: 'DD944B',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '9E9C8E',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '66645A',
            },
        },
    },
    {
        id: 'theme_vip_3',
        title: i18n.t('石雾迷灰'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '2b3550',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'e9ebf5',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '727b97',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'c2cfee',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: '7c8ebb',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '455682',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '868ba6',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '5e658a',
            },
        },
    },
    {
        id: 'theme_vip_4',
        title: i18n.t('翡冷翠绿'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '01383b',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'ecffff',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '317b84',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: '8deae7',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: '35c5c2',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '108a89',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '0ac487',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '1E7054',
            },
        },
    },
    {
        id: 'theme_vip_5',
        title: i18n.t('故宫风韵'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '171616',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'f2e7e7',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: 'ca3d1f',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'f7dfb7',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: 'caa267',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: 'b9752a',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '8f3c1a',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '3c281d',
            },
        },
    },
    {
        id: 'theme_vip_6',
        title: i18n.t('敦煌梦境'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '1e282d',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'f5e9d4',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '236a78',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: '8edeed',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: '4190b6',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '284b5c',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: 'ef6c45',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: 'a64326',
            },
        },
    },
    {
        id: 'theme_vip_7',
        title: i18n.t('普罗旺斯'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '2f2958',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'f5e6f6',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '793ec7',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'e5bffe',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: 'db7eec',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '763582',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '4f6755',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '1d381e',
            },
        },
    },
    {
        id: 'theme_vip_8',
        title: i18n.t('开罗之光'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '382b26',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'fdf6e1',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: 'ad714d',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'e2ccba',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: 'ac7f67',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '9c421f',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '948b82',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '58524c',
            },
        },
    },
    {
        id: 'theme_vip_9',
        title: i18n.t('只此青绿'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '1c2e29',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'ecf9f5',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '30867f',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'afe5c8',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: '589a76',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '3e6f53',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: 'dbbb69',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '8c7338',
            },
        },
    },
    {
        id: 'theme_vip_10',
        title: i18n.t('日出印象'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '271016',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'ece9f9',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '7c7891',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'ddd1e0',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: 'bca0b8',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '7c7891',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: 'ecbda7',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '866753',
            },
        },
    },
    {
        id: 'theme_vip_11',
        title: i18n.t('星空之夜'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '102443',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'f3edc1',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: '114799',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'fecf56',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: '68a8ca',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: '3882b5',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: '1b5789',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: 'afccc7',
            },
        },
    },
    {
        id: 'theme_vip_12',
        title: i18n.t('叠翠流金'),
        isVip: true,
        colorSchema: {
            dk1: DEFAULT_DK_1,
            lt1: DEFAULT_LT_1,
            hlink: DEFAULT_HLINK,
            folHlink: DEFAULT_FOLHLINK,
            dk2: {
                val: STSchemeColorVal.dk2,
                color: '3f3b34',
            },
            lt2: {
                val: STSchemeColorVal.lt2,
                color: 'f8f2e8',
            },
            accent1: {
                val: STSchemeColorVal.accent1,
                color: 'c09c5d',
            },
            accent2: {
                val: STSchemeColorVal.accent2,
                color: 'f0e0ca',
            },
            accent3: {
                val: STSchemeColorVal.accent3,
                color: 'DABD8E',
            },
            accent4: {
                val: STSchemeColorVal.accent4,
                color: 'b59465',
            },
            accent5: {
                val: STSchemeColorVal.accent5,
                color: 'c3b7a3',
            },
            accent6: {
                val: STSchemeColorVal.accent6,
                color: '737664',
            },
        },
    },
];

export const CUSTOM_THEME: Array<IThemeSelectItem> = [];

export const THEME_MAP = {
    [CLASSIC_KEY]: CLASSIC_THEME,
    [CUSTOM_KEY]: CUSTOM_THEME,
};

// const res: any = [];
// list2.forEach((itemList, index1) => {
//     const lumList = list1[index1];
//     const temp: any = [];
//     itemList.forEach((item, index) => {
//         const lum = lumList[index - 1];
//         if (index === 0) {
//             temp[index] = { ...item };
//         } else {
//             temp[index] = { ...item, ...lum };
//         }
//         temp[index].key = STSchemeColorVal[index1 + 1];
//     });
//     res.push(temp);
// });
//
// console.log(res);

//
// export const list1 = [
//     [
//         {
//             lumMod: 95000,
//             tips: '5%',
//         },
//         {
//             lumMod: 85000,
//             tips: '15%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 65000,
//             tips: '35%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 50000,
//             lumOff: 50000,
//             tips: '50%',
//         },
//         {
//             lumMod: 65000,
//             lumOff: 35000,
//             tips: '35%',
//         },
//         {
//             lumMod: 75000,
//             lumOff: 25000,
//             tips: '25%',
//         },
//         {
//             lumMod: 85000,
//             lumOff: 15000,
//             tips: '15%',
//         },
//         {
//             lumMod: 95000,
//             lumOff: 5000,
//             tips: '5%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
//     [
//         {
//             lumMod: 20000,
//             lumOff: 80000,
//             tips: '80%',
//         },
//         {
//             lumMod: 40000,
//             lumOff: 60000,
//             tips: '60%',
//         },
//         {
//             lumMod: 60000,
//             lumOff: 40000,
//             tips: '40%',
//         },
//         {
//             lumMod: 75000,
//             tips: '25%',
//         },
//         {
//             lumMod: 50000,
//             tips: '50%',
//         },
//     ],
// ];
//
// export const list2 = [
//     [
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 255,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 242,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 216,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 191,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 165,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 147,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 0,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 127,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 89,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 63,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 38,
//             },
//         },
//         {
//             hsl: {
//                 H: 0,
//                 S: 0,
//                 L: 13,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 219.37499999999997,
//                 S: 46.36363636363637,
//                 L: 88,
//             },
//         },
//         {
//             hsl: {
//                 H: 209.99999999999974,
//                 S: 51.00000000000021,
//                 L: 244.99999999999997,
//             },
//         },
//         {
//             hsl: {
//                 H: 218.57142857142858,
//                 S: 34.99999999999994,
//                 L: 204,
//             },
//         },
//         {
//             hsl: {
//                 H: 217.99999999999997,
//                 S: 34.15178571428572,
//                 L: 143,
//             },
//         },
//         {
//             hsl: {
//                 H: 217.49999999999994,
//                 S: 33.44262295081966,
//                 L: 60.99999999999999,
//             },
//         },
//         {
//             hsl: {
//                 H: 221.99999999999994,
//                 S: 31.09756097560976,
//                 L: 40.99999999999999,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 218.42364532019707,
//                 S: 230.06666666666672,
//                 L: 142.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 216.9230769230769,
//                 S: 255,
//                 L: 242,
//             },
//         },
//         {
//             hsl: {
//                 H: 217.49999999999994,
//                 S: 255,
//                 L: 227,
//             },
//         },
//         {
//             hsl: {
//                 H: 218.23529411764704,
//                 S: 255,
//                 L: 204,
//             },
//         },
//         {
//             hsl: {
//                 H: 218.0487804878049,
//                 S: 204.99999999999997,
//                 L: 102,
//             },
//         },
//         {
//             hsl: {
//                 H: 217.9591836734693,
//                 S: 204.8360655737705,
//                 L: 61,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 200.08163265306112,
//                 S: 255,
//                 L: 122.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 200.7692307692308,
//                 S: 255,
//                 L: 242,
//             },
//         },
//         {
//             hsl: {
//                 H: 200.35714285714278,
//                 S: 255,
//                 L: 227,
//             },
//         },
//         {
//             hsl: {
//                 H: 200.00000000000006,
//                 S: 255,
//                 L: 204,
//             },
//         },
//         {
//             hsl: {
//                 H: 200.00000000000006,
//                 S: 204.83606557377053,
//                 L: 91.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 199.75609756097555,
//                 S: 204.99999999999997,
//                 L: 51,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 147.7358490566038,
//                 S: 132.5,
//                 L: 101.99999999999999,
//             },
//         },
//         {
//             hsl: {
//                 H: 146.25,
//                 S: 156.92307692307696,
//                 L: 242,
//             },
//         },
//         {
//             hsl: {
//                 H: 147.69230769230774,
//                 S: 122.77777777777771,
//                 L: 214.49999999999997,
//             },
//         },
//         {
//             hsl: {
//                 H: 148.57142857142856,
//                 S: 112.34265734265738,
//                 L: 183.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 148.23529411764704,
//                 S: 132.9754601226994,
//                 L: 81.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 148.88888888888886,
//                 S: 135,
//                 L: 51,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 2.1428571428571352,
//                 S: 183.07692307692307,
//                 L: 138,
//             },
//         },
//         {
//             hsl: {
//                 H: 2.6086956521738847,
//                 S: 255,
//                 L: 243.49999999999997,
//             },
//         },
//         {
//             hsl: {
//                 H: 2.1428571428571352,
//                 S: 255,
//                 L: 227,
//             },
//         },
//         {
//             hsl: {
//                 H: 1.764705882352935,
//                 S: 255,
//                 L: 204,
//             },
//         },
//         {
//             hsl: {
//                 H: 1.8181818181818699,
//                 S: 182.93478260869568,
//                 L: 92,
//             },
//         },
//         {
//             hsl: {
//                 H: 2.4324324324324076,
//                 S: 184.99999999999997,
//                 L: 51,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 28.151658767772503,
//                 S: 239.13333333333335,
//                 L: 142.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 23.999999999999993,
//                 S: 255,
//                 L: 244.99999999999997,
//             },
//         },
//         {
//             hsl: {
//                 H: 24.406779661016962,
//                 S: 255,
//                 L: 225.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 26.34146341463413,
//                 S: 255,
//                 L: 193.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 27.8048780487805,
//                 S: 204.99999999999997,
//                 L: 102,
//             },
//         },
//         {
//             hsl: {
//                 H: 27.8048780487805,
//                 S: 204.99999999999997,
//                 L: 51,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 48.00000000000003,
//                 S: 255,
//                 L: 122.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 47.142857142857096,
//                 S: 255,
//                 L: 241,
//             },
//         },
//         {
//             hsl: {
//                 H: 47.56097560975613,
//                 S: 255,
//                 L: 214,
//             },
//         },
//         {
//             hsl: {
//                 H: 47.83216783216781,
//                 S: 255,
//                 L: 183.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 47.85276073619637,
//                 S: 255,
//                 L: 81.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 48.235294117647044,
//                 S: 255,
//                 L: 51,
//             },
//         },
//     ],
//     [
//         {
//             hsl: {
//                 H: 276.98113207547175,
//                 S: 169.64435146443518,
//                 L: 135.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 294,
//                 S: 255,
//                 L: 244.99999999999997,
//             },
//         },
//         {
//             hsl: {
//                 H: 286.0714285714286,
//                 S: 255,
//                 L: 227,
//             },
//         },
//         {
//             hsl: {
//                 H: 277.69911504424783,
//                 S: 255,
//                 L: 198.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 277.89473684210526,
//                 S: 148.6196319018405,
//                 L: 81.5,
//             },
//         },
//         {
//             hsl: {
//                 H: 278,
//                 S: 150,
//                 L: 50.99999999999999,
//             },
//         },
//     ],
// ];

export interface IColorMapItem {
    hsl: IHSL,
    lumMod?: number,
    lumOff?: number,
    tips?: string,
    key: STSchemeColorVal,
}

export const COLOR_MAP: Array<Array<IColorMapItem>> = [
    [
        {
            hsl: {
                H: 0,
                S: 0,
                L: 255,
            },
            key: STSchemeColorVal.lt1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 242,
            },
            lumMod: 95000,
            tips: '5%',
            key: STSchemeColorVal.lt1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 216,
            },
            lumMod: 85000,
            tips: '15%',
            key: STSchemeColorVal.lt1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 191,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.lt1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 165,
            },
            lumMod: 65000,
            tips: '35%',
            key: STSchemeColorVal.lt1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 147,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.lt1,
        },
    ],
    [
        {
            hsl: {
                H: 0,
                S: 0,
                L: 0,
            },
            key: STSchemeColorVal.dk1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 127,
            },
            lumMod: 50000,
            lumOff: 50000,
            tips: '50%',
            key: STSchemeColorVal.dk1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 89,
            },
            lumMod: 65000,
            lumOff: 35000,
            tips: '35%',
            key: STSchemeColorVal.dk1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 63,
            },
            lumMod: 75000,
            lumOff: 25000,
            tips: '25%',
            key: STSchemeColorVal.dk1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 38,
            },
            lumMod: 85000,
            lumOff: 15000,
            tips: '15%',
            key: STSchemeColorVal.dk1,
        },
        {
            hsl: {
                H: 0,
                S: 0,
                L: 13,
            },
            lumMod: 95000,
            lumOff: 5000,
            tips: '5%',
            key: STSchemeColorVal.dk1,
        },
    ],
    [
        {
            hsl: {
                H: 219.37499999999997,
                S: 46.36363636363637,
                L: 88,
            },
            key: STSchemeColorVal.lt2,
        },
        {
            hsl: {
                H: 209.99999999999974,
                S: 51.00000000000021,
                L: 244.99999999999997,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.lt2,
        },
        {
            hsl: {
                H: 218.57142857142858,
                S: 34.99999999999994,
                L: 204,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.lt2,
        },
        {
            hsl: {
                H: 217.99999999999997,
                S: 34.15178571428572,
                L: 143,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.lt2,
        },
        {
            hsl: {
                H: 217.49999999999994,
                S: 33.44262295081966,
                L: 60.99999999999999,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.lt2,
        },
        {
            hsl: {
                H: 221.99999999999994,
                S: 31.09756097560976,
                L: 40.99999999999999,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.lt2,
        },
    ],
    [
        {
            hsl: {
                H: 218.42364532019707,
                S: 230.06666666666672,
                L: 142.5,
            },
            key: STSchemeColorVal.dk2,
        },
        {
            hsl: {
                H: 216.9230769230769,
                S: 255,
                L: 242,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.dk2,
        },
        {
            hsl: {
                H: 217.49999999999994,
                S: 255,
                L: 227,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.dk2,
        },
        {
            hsl: {
                H: 218.23529411764704,
                S: 255,
                L: 204,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.dk2,
        },
        {
            hsl: {
                H: 218.0487804878049,
                S: 204.99999999999997,
                L: 102,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.dk2,
        },
        {
            hsl: {
                H: 217.9591836734693,
                S: 204.8360655737705,
                L: 61,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.dk2,
        },
    ],
    [
        {
            hsl: {
                H: 200.08163265306112,
                S: 255,
                L: 122.5,
            },
            key: STSchemeColorVal.accent1,
        },
        {
            hsl: {
                H: 200.7692307692308,
                S: 255,
                L: 242,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.accent1,
        },
        {
            hsl: {
                H: 200.35714285714278,
                S: 255,
                L: 227,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.accent1,
        },
        {
            hsl: {
                H: 200.00000000000006,
                S: 255,
                L: 204,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.accent1,
        },
        {
            hsl: {
                H: 200.00000000000006,
                S: 204.83606557377053,
                L: 91.5,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.accent1,
        },
        {
            hsl: {
                H: 199.75609756097555,
                S: 204.99999999999997,
                L: 51,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.accent1,
        },
    ],
    [
        {
            hsl: {
                H: 147.7358490566038,
                S: 132.5,
                L: 101.99999999999999,
            },
            key: STSchemeColorVal.accent2,
        },
        {
            hsl: {
                H: 146.25,
                S: 156.92307692307696,
                L: 242,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.accent2,
        },
        {
            hsl: {
                H: 147.69230769230774,
                S: 122.77777777777771,
                L: 214.49999999999997,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.accent2,
        },
        {
            hsl: {
                H: 148.57142857142856,
                S: 112.34265734265738,
                L: 183.5,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.accent2,
        },
        {
            hsl: {
                H: 148.23529411764704,
                S: 132.9754601226994,
                L: 81.5,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.accent2,
        },
        {
            hsl: {
                H: 148.88888888888886,
                S: 135,
                L: 51,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.accent2,
        },
    ],
    [
        {
            hsl: {
                H: 2.1428571428571352,
                S: 183.07692307692307,
                L: 138,
            },
            key: STSchemeColorVal.accent3,
        },
        {
            hsl: {
                H: 2.6086956521738847,
                S: 255,
                L: 243.49999999999997,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.accent3,
        },
        {
            hsl: {
                H: 2.1428571428571352,
                S: 255,
                L: 227,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.accent3,
        },
        {
            hsl: {
                H: 1.764705882352935,
                S: 255,
                L: 204,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.accent3,
        },
        {
            hsl: {
                H: 1.8181818181818699,
                S: 182.93478260869568,
                L: 92,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.accent3,
        },
        {
            hsl: {
                H: 2.4324324324324076,
                S: 184.99999999999997,
                L: 51,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.accent3,
        },
    ],
    [
        {
            hsl: {
                H: 28.151658767772503,
                S: 239.13333333333335,
                L: 142.5,
            },
            key: STSchemeColorVal.accent4,
        },
        {
            hsl: {
                H: 23.999999999999993,
                S: 255,
                L: 244.99999999999997,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.accent4,
        },
        {
            hsl: {
                H: 24.406779661016962,
                S: 255,
                L: 225.5,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.accent4,
        },
        {
            hsl: {
                H: 26.34146341463413,
                S: 255,
                L: 193.5,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.accent4,
        },
        {
            hsl: {
                H: 27.8048780487805,
                S: 204.99999999999997,
                L: 102,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.accent4,
        },
        {
            hsl: {
                H: 27.8048780487805,
                S: 204.99999999999997,
                L: 51,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.accent4,
        },
    ],
    [
        {
            hsl: {
                H: 48.00000000000003,
                S: 255,
                L: 122.5,
            },
            key: STSchemeColorVal.accent5,
        },
        {
            hsl: {
                H: 47.142857142857096,
                S: 255,
                L: 241,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.accent5,
        },
        {
            hsl: {
                H: 47.56097560975613,
                S: 255,
                L: 214,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.accent5,
        },
        {
            hsl: {
                H: 47.83216783216781,
                S: 255,
                L: 183.5,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.accent5,
        },
        {
            hsl: {
                H: 47.85276073619637,
                S: 255,
                L: 81.5,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.accent5,
        },
        {
            hsl: {
                H: 48.235294117647044,
                S: 255,
                L: 51,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.accent5,
        },
    ],
    [
        {
            hsl: {
                H: 276.98113207547175,
                S: 169.64435146443518,
                L: 135.5,
            },
            key: STSchemeColorVal.accent6,
        },
        {
            hsl: {
                H: 294,
                S: 255,
                L: 244.99999999999997,
            },
            lumMod: 20000,
            lumOff: 80000,
            tips: '80%',
            key: STSchemeColorVal.accent6,
        },
        {
            hsl: {
                H: 286.0714285714286,
                S: 255,
                L: 227,
            },
            lumMod: 40000,
            lumOff: 60000,
            tips: '60%',
            key: STSchemeColorVal.accent6,
        },
        {
            hsl: {
                H: 277.69911504424783,
                S: 255,
                L: 198.5,
            },
            lumMod: 60000,
            lumOff: 40000,
            tips: '40%',
            key: STSchemeColorVal.accent6,
        },
        {
            hsl: {
                H: 277.89473684210526,
                S: 148.6196319018405,
                L: 81.5,
            },
            lumMod: 75000,
            tips: '25%',
            key: STSchemeColorVal.accent6,
        },
        {
            hsl: {
                H: 278,
                S: 150,
                L: 50.99999999999999,
            },
            lumMod: 50000,
            tips: '50%',
            key: STSchemeColorVal.accent6,
        },
    ],
];
